// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";
import type { ComponentPropsWithRef } from "react";

import { Icon } from "metabase/ui";
import { color } from "metabase/ui/utils/colors";
interface SelectButtonRootProps {
  hasValue: boolean;
  fullWidth: boolean;
  highlighted: boolean;
}

const getColor = ({ hasValue, highlighted }: SelectButtonRootProps) => {
  if (hasValue) {
    return highlighted ? color("text-primary-inverse") : color("text-primary");
  } else {
    return color("text-disabled");
  }
};

export const SelectButtonRoot = styled.button<SelectButtonRootProps>`
  padding: 0.625rem 0.75rem;
  cursor: pointer;
  display: flex;
  width: ${(props) => (props.fullWidth ? "100%" : "unset")};
  align-items: center;
  border: 1px solid
    ${({ hasValue, highlighted }) =>
      hasValue && highlighted ? color("core-brand") : color("border-neutral")};
  background-color: ${({ hasValue, highlighted }) =>
    hasValue && highlighted
      ? color("core-brand")
      : color("background_page-primary")};
  border-radius: var(--mantine-spacing-sm);
  font-weight: 700;
  min-width: 104px;
  color: ${getColor};

  &:hover {
    border-color: var(--mb-color-core-brand);
  }

  &:focus {
    border-color: var(--mb-color-core-brand);
    outline: 2px solid var(--mb-color-input-focus);
  }

  &:not(:focus-visible) {
    outline: none;
  }

  &:disabled {
    background-color: var(--mb-color-background_page-secondary);
    color: var(--mb-color-text-secondary);
    pointer-events: none;
  }
`;

interface SelectButtonIconProps {
  hasValue: boolean;
  highlighted: boolean;
}

export const SelectButtonIcon = styled(
  ({
    hasValue,
    highlighted,
    ...rest
  }: SelectButtonIconProps & ComponentPropsWithRef<typeof Icon>) => (
    <Icon {...rest} />
  ),
)`
  display: flex;
  margin-left: auto;
  color: ${({ hasValue, highlighted }) =>
    hasValue && highlighted
      ? color("text-primary-inverse")
      : color("text-secondary")};
`;

export const SelectButtonContent = styled.span`
  margin-right: 0.5rem;
`;
